export default {
      id: "to-register-logo-usage",
      viewBox: "0 0 58 68",
      url: __webpack_public_path__ + "svgsprite.svg#to-register-logo",
      toString: function () {
        return this.url;
      }
    }